// extracted by mini-css-extract-plugin
module.exports =  {"list":"d5vNeAJDkhENzIvXKqqO"};